import axios from "axios";
import { Cookies } from "react-cookie";

const cookie = new Cookies();
const endPoint = `/order`;

// export const createOrder = async ({
//   cartItems,
//   phone,
//   country,
//   name,
//   address,
//   city,
//   payment,
//   totalPrice,
// }) => {
//   const token = cookie.get("user");
//   if (token) {
//     return await axios.post(
//       `${endPoint}/create`,
//       {
//         cartItems,
//         phone,
//         country,
//         name,
//         address,
//         city,
//         payment,
//         totalPrice,
//       },
//       {
//         headers: { Authorization: token },
//       }
//     );
//   } else return false;
// };

// create order version 2


//v2
export const createOrder2 = async ({
  cartItems,
  phone,
  country,
  name,
  address,
  city,
  payment,
  totalPrice,
}) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.post(
      `${endPoint}/create2`,
      {
        cartItems,
        phone,
        country,
        name,
        address,
        city,
        payment,
        totalPrice,
      },
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};
//v3

// export const createOrder3 = async ({
//   cartItems,
//   phone,
//   country,
//   name,
//   address,
//   city,
//   payment,
//   totalPrice,
// }) => {
//   const token = cookie.get("user");
//   if (token) {
//     return await axios.post(
//       `${endPoint}/createC`,
//       {
//         cartItems,
//         phone,
//         country,
//         name,
//         address,
//         city,
//         payment,
//         totalPrice,
//       },
//       {
//         headers: { Authorization: token },
//       }
//     );
//   } else return false;
// };


export const getUserOrders = async () => {
  const token = cookie.get("user");
  return await (
    await axios.get(`${endPoint}/myorders`, {
      headers: { Authorization: token },
    })
  ).data;
};

export const getReturnOrders = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/myreturns`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};

export const getReplacementsOrders = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/User_replacements`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};





export const getPopUpReturnOrders = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/myreturnslast15day`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};



export const getPopUpReplacementOrders = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/myreplacementslast15day`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};




export const addtReturnOrder = async (id) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.post(
      `${endPoint}/requestreturn/${id}`,
      {
        id
      },
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};



export const addtReplacementOrder = async (id) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.post(
      `${endPoint}/requestreplacement/${id}`,
      {
        id
      },
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};

export const cancelOrder = async (id) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.put(
      `${endPoint}/cancelorder/${id}`,
      {}
    );
  } else return false;
};


export const changeReturnStatus = async (id) => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.put(
      `${endPoint}/changereturnstatus/${id}`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};

export const changeReplaceStatus = async (id) => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.put(
      `${endPoint}/changereplacestatus/${id}`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};

